import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import { SelectField, InputField, CheckboxField } from 'Common/SemanticWrapper';
import { ControlInfoEnum } from 'Common/FieldEnum';
import { EDIT_CASE_TYPE_FORM_NAME } from 'Common/FormEnum';

class EditCaseTypeForm extends Component {
  componentDidUpdate(prevProps) {
    const { formValues } = this.props;

    if (
      formValues &&
      formValues.IsSNAPEquivalent &&
      !prevProps.formValues.IsSNAPEquivalent
    ) {
      this.props.dispatch(change(EDIT_CASE_TYPE_FORM_NAME, 'Status', 2));
    }

    if (
      formValues &&
      !formValues.IsDCOnly &&
      formValues.Status === 3 &&
      !prevProps.formValues.Status !== 3
    ) {
      this.props.dispatch(change(EDIT_CASE_TYPE_FORM_NAME, 'IsDCOnly', true));
    }
  }

  render() {
    const { initialValues, isAdd, formValues } = this.props;
    const isDefault = parseInt(initialValues.Id, 10) < 100;

    return (
      <Form onSubmit={this.props.onSubmit}>
        <Grid>
          <Grid.Column width={16}>
            <Field
              name={ControlInfoEnum.Enabled}
              component={CheckboxField}
              toggle
              label={'Enabled'}
              disabled={!isAdd && initialValues.InUseThisYear}
            />
          </Grid.Column>
          <Grid.Column
            width={16}
            style={{ paddingTop: '0px', paddingBottom: '0px' }}
          >
            <Field
              name={ControlInfoEnum.Description}
              component={InputField}
              type="text"
              label={'Case Type'}
              fluid
              required
              maxLength={15}
              disabled={isDefault || initialValues.InUseAllTime}
            />
          </Grid.Column>
          <Grid.Column
            width={16}
            style={{ paddingTop: '0px', paddingBottom: '0px' }}
          >
            <Field
              fluid
              name={ControlInfoEnum.Status}
              component={SelectField}
              label={'Benefit Level'}
              options={[
                { key: '2', value: 2, text: 'Free' },
                { key: '3', value: 3, text: 'Reduced' },
              ]}
              required
              disabled={
                isDefault ||
                initialValues.InUseAllTime ||
                (formValues && formValues.IsSNAPEquivalent)
              }
            />
          </Grid.Column>
          <Grid.Row columns={2}>
            <Grid.Column width={8}>
              <Field
                name={ControlInfoEnum.IsSNAPEquivalent}
                component={CheckboxField}
                label={'SNAP Equivalent'}
                disabled={isDefault || initialValues.InUseAllTime}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Field
                name={ControlInfoEnum.IsDCOnly}
                component={CheckboxField}
                label={'DC Only'}
                disabled={
                  isDefault ||
                  initialValues.InUseAllTime ||
                  (formValues && formValues.Status === 3)
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(EDIT_CASE_TYPE_FORM_NAME)(state),
  };
};

const validate = values => {
  const errors = {};

  if (!values[ControlInfoEnum.Description]) {
    errors[ControlInfoEnum.Description] = 'Case Type Description is required';
  }

  if (!values[ControlInfoEnum.Status]) {
    errors[ControlInfoEnum.Status] = 'Benefit Level is required';
  }

  return errors;
};

EditCaseTypeForm = connect(mapStateToProps)(EditCaseTypeForm);

export default reduxForm({
  form: EDIT_CASE_TYPE_FORM_NAME,
  validate,
})(EditCaseTypeForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/EditCaseTypeForm.js